import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import useKeys from "./useKeys";
import useToken from "./useToken"
import { Typography, Skeleton } from "antd";

const TestKeys = () => {
  const [accessToken, setAccessToken] = useState("");
  const { keys, isLoading } = useKeys("test");
  const {token, tokenLoading} = useToken();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        rowGap: "14px",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "24px",
          borderRadius: "16px",
          border: "1px solid #507FFB",
          rowGap: "10px",
          width: "100%",
        }}
      >
        <Typography.Title level={4} style={{ width: "80%" }}>
          Test keys
        </Typography.Title>
        <Typography.Text style={{ width: "80%" }}>
          You can use Test API Key to check out how our technologies work.
        </Typography.Text>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "4px",
            width: "100%",
          }}
        >
          <span> Test API Key</span>
          <div
            style={{
              border: "1px solid #707070",
              borderRadius: "8px",
              padding: "4px",
              width: "100%",
              minHeight: "32px",
            }}
          >
            <Skeleton loading={isLoading} active title={false} paragraph={{ rows: 1 }}>
              <Typography.Text copyable className="settings-api-tab-key">
                {keys[0]?.api_key}
              </Typography.Text>
            </Skeleton>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "4px",
            width: "100%",
          }}
        >
          <span> Test Access Token</span>
          <div
            style={{
              border: "1px solid #707070",
              borderRadius: "8px",
              padding: "4px",
              width: "100%",
              minHeight: "32px",
            }}
          >
            <Skeleton loading={tokenLoading} active title={false} paragraph={{rows: 1}}>
            {token?.length > 0 && (
              <Typography.Text copyable className="settings-api-tab-key settings-access-token">
                {token[0]?.access_token}
              </Typography.Text>
            )}
            </Skeleton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestKeys;
